<template>
  <inline-edit
    :action="route('settings.job-priorities')"
    title="Edit job priorities"
    save-label="Calculate job score"
    v-bind="{ user }"
  >
    <template v-if="$slots.default" #activator="{ activator }">
      <slot v-bind="{ activator }"/>
    </template>

    <p class="leading-relaxed">
      Job Score for each school reflects how closely a school's job outcomes match your goals.
      Higher scores are better, all else equal.
      This is derived from your job priorities set below.
    </p>

    <l-job-priorities-input
      v-model="user.report"
      class="grid gap-3"
    />
  </inline-edit>
</template>

<script setup>
import InlineEdit from "@/components/inlines/InlineEdit.vue"
import LJobPrioritiesInput from "@/components/inputs/LJobPrioritiesInput.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object })
</script>
